export enum Verrechnungsart {
    NichtVerrechenbar = 0,
    Offen = 1,
    InBearbeitung = 2,
    Bezahlt = 3,
}
